import React from "react";
import {
  Card,
  CardLeft,
  CardRight,
  TechCardContainer,
  TechCard,
  BtnGroup,
} from "./MediumCardElements";
function MediumCard({ projects }) {
  return (
    <>
      {projects.map((list, index) => (
        <Card>
          <CardLeft>
            <img src={list.img} alt={list.name} />
          </CardLeft>
          <CardRight>
            <h4>{list.title}</h4>
            <p>{list.description}</p>
            
            {/* {(list.contribution && 
            <>
              <hr style={{width: '90%'}} />
              <p>{list.contribution}</p>
            </> 
           )} */}

            <TechCardContainer>
              {list.tech_stack.map((tech, index) => (
                <TechCard key={index}>{tech}</TechCard>
              ))}
            </TechCardContainer>
            <BtnGroup>
              {list.github_url && list.github_url.length > 0 && (
                <a
                  className="btn SecondaryBtn btn-shadow"
                  href={list.github_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Github
                </a>
              )}

              {list.app_store && list.app_store.length > 0 && (
                <a
                  className="btn SecondaryBtn btn-shadow"
                  href={list.app_store}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  IOS
                </a>
              )}

              {list.google_play && list.google_play.length > 0 && (
                <a
                  className="btn SecondaryBtn btn-shadow"
                  href={list.google_play}
                  target="_blank"

                  rel="noopener noreferrer"
                >
                  Android
                </a>
              )}

              {list.tailer_url && list.tailer_url.length > 0 && (
                <a
                  className="btn PrimaryBtn btn-shadow"
                  href={list.tailer_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Trailer
                </a>
              )}

            </BtnGroup>
          </CardRight>
        </Card>
      ))}
    </>
  );
}

export default MediumCard;
